import { createTheme } from "@mui/material/styles";

export const theme = {
  mainColor: "#E87975",
  zweitFarbe: "#666666",
  mainTextColor: "#383838",
  hoverColor: "#f86b6b",

  // old defined ones

  buttonDisabledColor: "#cccccc",

  primary: "#EFD2D2",
  primaryColor: "#c23d3e",
  primaryAccentColor: "#F86B6B",

  fourthColor: "#545454",

  secondaryColor: "#001B3C",
  headerTitleColor: "#383838",

  thirdColor: "#383838",

  secondaryHeadlineColor: "#443e3e",

  chatFontColor: "#383838",
  scrollBarColor: "lightgrey",
  
  // Message colors
  userMessageColor: "#FFBCBD",
  receivedMessageColor: "#F0F0F0",

  greyTextColor: "#787878",
  abrilFatfaceLetterSpacing: "0.5px",
  questionColor: "#7899BF",
  placeholderColor: "lightgrey",
  detailPageContainerBoxShadow: "0px 2px 6px rgba(0, 0, 0, 0.3)",
  detailPageContainerBorderRadius: "8px 8px 0 0",

  listHeaderFontSize: "22px",
  detailPageHeaderFontSize: "26px",
  smallHeaderFontSize: "20px",
  mediumFontSize: "14px",
  smallFontSize: "12px",

  headerFontWeight: "500",
  searchBarContainerHeight: "50px",
  detailPageWidth: "85%",
  detailPageMinWidth: "550px",
  detailPageMinHeight: "100%",
  inputBorderColor: "#9c9c9c",
  inputErrorBorderColor: "red",

  brightStuffColor: "#e0e0e0",

  hoverBrightStuffColor: "#fff",
  beforeHoverTextColor: "#808080",
  hoverTextColor: "#262626",

  firstBreakpoint: 1040,
  secondBreakpoint: 980,
  xsDevicesBreakpoint: "575px",
};

export const muiTheme = createTheme({
  palette: {
    primary: {
      main: "#E87975",
      light: "#f86b6b",
      dark: "#c23d3e",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#001B3C",
      light: "#666666",
      dark: "#000000",
      contrastText: "#ffffff",
    },
    text: {
      primary: "#383838",
      secondary: "#787878",
    },
    background: {
      default: "#ffffff",
      paper: "#ffffff",
    },
    grey: {
      50: "#fafafa",
      100: "#f5f5f5",
      200: "#eeeeee",
      300: "#e0e0e0",
      400: "#bdbdbd",
      500: "#9e9e9e",
      600: "#757575",
      700: "#616161",
      800: "#424242",
      900: "#212121",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: "26px",
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: "22px",
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h3: {
      fontSize: "20px",
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h4: {
      fontSize: "18px",
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h5: {
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: 1.5,
    },
    h6: {
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: 1.5,
    },
    body1: {
      fontSize: "14px",
      lineHeight: 1.5,
    },
    body2: {
      fontSize: "12px",
      lineHeight: 1.5,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 980, // Using your secondBreakpoint
      lg: 1040, // Using your firstBreakpoint
      xl: 1200,
    },
  },
  spacing: 8, // 8px base spacing unit
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiDialogActions: {
      styleOverrides: {
        root: {
          display: "flex",
          justifyContent: "center",
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: "black",
        },
        arrow: {
          "&::before": {
            backgroundColor: "black",
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: "0px 2px 7px rgba(0, 0, 0, 0.35)",
          borderRadius: "20px",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: "#383838",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: "16px",
        },
      },
    },
  },
});
